import { useTranslation } from '@mc/i18n'
import { TrackingRow } from 'pages/certificates/components'
import {
  HeroVariant,
  type HeroVariantProps,
} from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import { PassOnlyHeroModule } from '../PassOnlyHeroModule'
import { PassPriceLockup } from '../PassPriceLockup'
import { MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE } from '../i18n'
import { getPassMonthlyPrice } from './getPassMonthlyPrice'

export const HeroVariantPassOnlyMonthly = (props: HeroVariantProps) => {
  const { t } = useTranslation(MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE)
  const monthlyPrice = getPassMonthlyPrice(
    props.subscriptionOffer?.subscriptionPlan?.pricing,
    t('passOnlyHero.monthlySuffix'),
  )

  return (
    <TrackingRow
      row_name='hero-subs-only-monthly'
      location='hero-subs-only-monthly'
      visibilityConfig={{ threshold: 0.01 }}
    >
      <HeroVariant {...props} releaseLabel={props.program.releaseLabel}>
        <PassOnlyHeroModule
          priceLockup={
            <PassPriceLockup
              {...monthlyPrice}
              note={t('passOnlyHero.billedAnnually')}
            />
          }
        />
      </HeroVariant>
    </TrackingRow>
  )
}
